import { CSSProperties, FC, lazy, Suspense } from 'react'

import { clsx } from 'clsx'

import {
  FormControl,
  FormControlProps,
} from '@tribeplatform/react-ui-kit/FormControl'

const Composer = lazy(() =>
  import('../Composer/Composer.js').then(m => ({ default: m.Composer })),
)
const ComposerControls = lazy(() =>
  import('../Composer/components/ComposerControls.js').then(m => ({
    default: m.ComposerControls,
  })),
)
const ComposerProvider = lazy(() =>
  import('../Composer/ComposerProvider.js').then(m => ({
    default: m.ComposerProvider,
  })),
)

export type FormControlHtmlEditorProps = FormControlProps & {
  value?: string
  onChange?: (value: string) => void
  className?: string
  style?: CSSProperties
}

export const FormControlHtmlEditor: FC<FormControlHtmlEditorProps> = ({
  placeholder,
  name,
  value,
  error,
  invalid,
  label,
  helperText,
  onChange,
  className,
  style,
}) => {
  return (
    <div className={clsx('space-y-1', className)}>
      {label && <FormControl.Label htmlFor={name}>{label}</FormControl.Label>}
      <Suspense fallback={<></>}>
        <ComposerProvider
          content={value}
          placeholder={placeholder}
          editorOptions={{
            onUpdate: ({ editor }) => {
              onChange(editor.isEmpty ? '' : editor.getHTML())
            },
          }}
        >
          <div
            // h-28 is not working !?
            style={{ minHeight: '114px', ...style }}
            className={clsx(
              'flex flex-col relative shadow-sm min-h-28 px-3 py-2 border h-full w-full rounded-md space-y-2',
              'text-content-subdued bg-surface placeholder:text-content-subdued placeholder:opacity-60 border-line',
              'focus-within:ring-1 focus-within:ring-offset-0',
              'focus-within:ring-focused focus-within:border-focused',
              invalid &&
                'pe-10 outline ring-line-negative border-line-negative',
            )}
          >
            <Composer minLines={8} />
            <ComposerControls />
          </div>
        </ComposerProvider>
      </Suspense>
      <FormControl.Meta
        invalid={invalid}
        error={error}
        helperText={helperText}
      />
    </div>
  )
}
